module.exports = __webpack_public_path__ + "static/Jake-01a1ffff8bb42ea66d0eeda73d92e468.png";